export default __webpack_public_path__ + "static/media/logout-navIcon.9d1ea177.svg";